"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _Select = _interopRequireDefault(require("../Select"));

var _Input = _interopRequireDefault(require("../Input"));

var _Countries = _interopRequireDefault(require("../../data/Countries"));

var _Provinces = _interopRequireDefault(require("../../data/Provinces"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var renderOption = function renderOption(province) {
  var name = province.name;
  return _react.default.createElement("option", {
    key: name,
    value: name
  }, name);
};

renderOption.displayName = 'renderOption';

var findProvinces = function findProvinces(country) {
  var countryInfo = _Countries.default.find(function (c) {
    return c.name === country;
  });

  if (!countryInfo) return [];
  return _Provinces.default.filter(function (province) {
    return province.cca3 === countryInfo.cca3;
  });
};

var sanitizeValue = function sanitizeValue(countryProvinces, value) {
  if (value === '') return '';
  var isValueValid = countryProvinces.some(function (province) {
    return province.name === value;
  });
  return isValueValid ? value : '';
};

var ProvincePicker = function ProvincePicker(_ref) {
  var country = _ref.country,
      placeholder = _ref.placeholder,
      textPlaceholder = _ref.textPlaceholder,
      value = _ref.value,
      props = _objectWithoutPropertiesLoose(_ref, ["country", "placeholder", "textPlaceholder", "value"]);

  var countryProvinces = findProvinces(country);
  return countryProvinces.length > 0 ? _react.default.createElement(_Select.default, _extends({
    placeholder: placeholder,
    value: sanitizeValue(countryProvinces, value)
  }, props), countryProvinces.sort(function (a, b) {
    return a.name.localeCompare(b.name);
  }).map(renderOption)) : _react.default.createElement(_Input.default, _extends({
    type: "text",
    placeholder: textPlaceholder || placeholder,
    value: value
  }, props));
};

ProvincePicker.displayName = 'ProvincePicker';
ProvincePicker.propTypes = {
  country: _propTypes.string.isRequired,
  name: _propTypes.string.isRequired,
  placeholder: _propTypes.string,
  textPlaceholder: _propTypes.string,
  value: _propTypes.string
};
ProvincePicker.defaultProps = {
  placeholder: undefined,
  textPlaceholder: undefined,
  value: ''
};
var _default = ProvincePicker;
exports.default = _default;